<template>
  <CustomModal ref="modal" title="Modules">
    <div class="container">
      <p>
        Actuellement, l’ajout ou la suppression d’un module doit être effectué par un modérateur du logiciel.
        Rassurez-vous, cette étape sera prochainement automatisée. Toutefois, pour des raisons de sécurité des données
        et de facturation, cette opération reste pour l’instant encadrée.
      </p>
      <p>
        Pour toute demande ou information complémentaire, vous pouvez me contacter au 06 14 85 18 19.
        N’hésitez pas à laisser un message en cas d’indisponibilité.
      </p>
      <p>
        Pour effectuer la demande, cliquez sur le bouton si dessous.
      </p>
      <CustomForm ref="form" :submit=buttons.submit>
        <CustomButton class="button" @click="submitForm" :params=buttons.submit />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
  import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
  import CustomForm from "@/components/forms/CustomForm.vue";
  import {NotificationService} from "@vues/v-common";
  import CustomModal from "@/components/modals/CustomModal.vue";
  import {OptionController} from "@/controllers/user/OptionController";

  export default {
      name: 'ConfirmOptionModal',
      components: {CustomModal, CustomForm, CustomButton},
      data() {
        return {
          option : undefined,
          buttons:{
            submit: {text: "Ajouter", disabled: true}
          }
        };
      },
      methods: {
        openModal(option) {
          this.$refs.modal.openModal();
          this.option = option;
          this.startResetPasswordTimer();
        },
        closeModal(event = false) {
          this.$refs.modal?.closeModal(event);
        },
        startResetPasswordTimer() {
          this.timer = 10;
          this.buttons.submit.disabled = true;
          this.buttons.submit.text = `Envoyer une demande (${this.timer}s)`;
          const interval = setInterval(() => {
            if(this.timer > 0) {
              this.timer--;
              this.buttons.submit.text = `Envoyer une demande (${this.timer}s)`;
            }
          },1000);
          setTimeout(() => {
            clearInterval(interval);
            this.buttons.submit.text = `Envoyer une demande`;
            this.buttons.submit.disabled = false;
          }, 10000);
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => OptionController.addOption(this.option.id));
          if (!res.errors) {
            (new NotificationService).addNotification("success","Demande envoyée");
            this.closeModal(true);
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    h2
      margin-bottom 0
      text-align center

    .container
      padding-left 15px
      padding-right 15px

      form
        display flex
        flex-direction row
        .select, .button
          margin-top 18px
        .select
          padding-right 10px
</style>
